import { Typography } from '../../atoms/typography/typography';

export interface CardSubheadProps {
  subheading: string;
}

export const CardSubhead = ({ subheading }: CardSubheadProps) => {
  return <Typography variant="textBodyMedium">{subheading}</Typography>;
};
